(function (window) {
  'use strict';

  const modalIdAttribute = 'data-modal-id';
  const modalTitleAttribute = 'data-modal-title';
  const modalDescriptionAttribute = 'data-modal-description';
  const modalVideoAttribute = 'data-modal-video';
  const modalShowClass = 'js-modal-show';
  const modalShowBodyClass = 'js-modal-open';
  let previousScrollTop = null;

  // Events are emitted for modal actions so that implementation JS can react
  // as needed. An example would be removing form validation errors that were
  // added by the implementation after an unsuccessful submission.
  function emitModalEvent(modalId, action) {
    componentEvents.emitEvent('modal-change', [{
      id: modalId,
      action: action
    }]);
  }

  // Allows modals to be open with the `'open-modal'` event and id argument.
  function handleOpenModalEvent(args) {
    if (args.id) {
      openModal(args.id, args.openerElement);
    }
  }

  // Allows modals to be closed with the `'close-modal'` event and id argument.
  function handleCloseModalEvent(args) {
    if (args.id) {
      closeModal(args.id, args.formReset);
    }
  }

  // Hide other areas of the page to screen readers.
  function a11yModal(modal) {
    if (!modal.temporarilyHidden) {
      const children = document.querySelectorAll(
        'body > :not(script):not(style):not(noscript):not([aria-hidden="true"])'
      );
      modal.temporarilyHidden = Array.prototype.slice.call(children)
        .filter(function (child) {
          return child !== modal;
        });

      for (let i = 0; i < modal.temporarilyHidden.length; i++) {
        modal.temporarilyHidden[i].setAttribute('aria-hidden', true);
      }
      modal.setAttribute('aria-modal', true);
      modal.focus();
    } else {
      for (let i = 0; i < modal.temporarilyHidden.length; i++) {
        modal.temporarilyHidden[i].removeAttribute('aria-hidden');
      }
      modal.setAttribute('aria-modal', false);
      modal.temporarilyHidden = null;
    }
  }

  function openModal(modalId, openerElement, modalTitle, modalDescription, modalVideo) {
    const modal = document.getElementById(modalId);
    const close = modal.querySelector('.js-modal-close-button');

    // Keep record of what was used to open this modal, so we can place focus
    // back on it when it’s closed.
    if (openerElement) {
      modal.openerElement = openerElement;
    }

    a11yModal(modal);

    if (modal) {
      const video = modal.querySelector('.js-modal-video');

      // iOS requires `body { position: fixed }` to prevent background scrolling
      // while the modal is open, which forces the page to jump to the top. The
      // following counteracts that jump.
      previousScrollTop = (document.documentElement.scrollTop || document.body.scrollTop);
      document.body.style.top = (-1 * previousScrollTop) + 'px';

      if (modalTitle) {
        modal.querySelector('.js-modal-title').innerText = modalTitle;
      }

      if (modalDescription) {
        modal.querySelector('.js-modal-description').innerText = modalDescription;
      }

      modal.addEventListener('keydown', handleKeydown);

      // Focus on the close button (nigh) immediately.
      window.setTimeout(function (el) {
        if (el) {
          el.focus();
        }
      }, 5, close);

      // Prevents unnecessary downloads by only creating the video at all when
      // the modal is opened.
      if (video) {
        const videoId = modalVideo || video.getAttribute('data-video-id');
        const youtubeScriptId = 'youtube-api';
        const youtubeScript = document.getElementById(youtubeScriptId);

        if (youtubeScript === null) {
          const tag = document.createElement('script');
          const firstScript = document.getElementsByTagName('script')[0];

          tag.src = 'https://www.youtube.com/iframe_api';
          tag.id = youtubeScriptId;
          firstScript.parentNode.insertBefore(tag, firstScript);
        } else if (typeof window.player !== 'undefined') {
          window.player.loadVideoById(videoId)
        }

        window.onYouTubeIframeAPIReady = function() {
          window.player = new window.YT.Player(video, {
            videoId: videoId,
            playerVars: {
              autoplay: 1,
              modestbranding: 1,
              rel: 0
            }
          });
        }
      }

      document.body.classList.add(modalShowBodyClass);
      modal.classList.add(modalShowClass);

      emitModalEvent(modalId, 'open');
    }
  }

  function closeModal(modalId, formReset = true) {
    const modal = document.getElementById(modalId);

    // Return the body to its state before the modal was opened.
    document.body.style.top = '';
    document.documentElement.scrollTop = document.body.scrollTop = previousScrollTop;

    if (modal) {
      const form = modal.querySelector('.js-modal-form');
      const video = modal.querySelector('.js-modal-video');
      const openerElement = modal.openerElement;

      modal.classList.remove(modalShowClass);

      // Add this class to modal forms that shouldn't be reset upon close.
      if (form && form.classList.contains('js-modal-form-no-reset')) {
        formReset = false;
      }

      if (form && formReset) {
        const selectItems = form.querySelectorAll('select');

        form.reset();

        // Trigger JS that sets the color when the empty option is selected.
        for (let i = 0; i < selectItems.length; i++) {
          triggerNativeEvent(selectItems[i], 'change');
        }
      }

      modal.removeEventListener('keydown', handleKeydown);

      if (video) {
        window.player.pauseVideo();
      }

      a11yModal(modal);
      document.body.classList.remove(modalShowBodyClass);

      // Place focus back on the original element that triggered opening it in
      // the first place, if it exists.
      if (openerElement) {
        openerElement.focus();
        modal.removeAttribute('data-opener-element');
      }

      emitModalEvent(modalId, 'close');
    }
  }

  function handleOpenModal(e) {
    const modalLink = e.target;
    const modalId = modalLink.getAttribute(modalIdAttribute);
    const modalTitle = modalLink.getAttribute(modalTitleAttribute);
    const modalDescription = modalLink.getAttribute(modalDescriptionAttribute);
    const modalVideo = modalLink.getAttribute(modalVideoAttribute);

    e.preventDefault();

    // Modal open links can dynamically alter the title and description of a
    // modal by having values for the `data-modal-title` and
    // `data-modal-description` attributes. Video modals can also be passed a
    // video URL with `data-modal-video`.
    openModal(modalId, modalLink, modalTitle, modalDescription, modalVideo);
  }

  function handleCloseModal(e) {
    e.preventDefault();

    closeModal(e.target.closest('.js-modal').getAttribute('id'));
  }

  function handleModalClick(e) {
    // Closes the modal if the overlay was clicked. The overlay element itself
    // has `pointer-events: none` assigned to it to fix scrolling on small
    // screens, so the event has to be added to the modal itself.
    if (e.target.classList.contains('js-modal')) {
      closeModal(e.target.getAttribute('id'));
    }
  }

  // Use global modal keydown handler.
  function handleKeydown(e) {
    handleModalKeydown(e, closeModal.bind(null, e.currentTarget.getAttribute('id')));
  }

  function init() {
    const modals = document.querySelectorAll('.js-modal');
    const modalOpenLinks = document.querySelectorAll('.js-modal-open-link');

    for (let i = 0; i < modals.length; i++) {
      if (!modals[i].classList.contains('js-component-init')) {
        const closeButtons = modals[i].querySelectorAll('.js-modal-close-button');

        modals[i].addEventListener('click', handleModalClick);

        for (let i = 0; i < closeButtons.length; i++) {
          closeButtons[i].addEventListener('click', handleCloseModal);
        }

        // Trap the users on video modals when open.
        const focusOnCloseButton = modals[i].querySelector('[data-focus-on-close-button]');

        if(!!focusOnCloseButton) {
          const modalCloseButton = modals[i].querySelector('.modal__close');
          focusOnCloseButton.addEventListener('focus', () => {
            modalCloseButton.focus();
          });
        }

        // Open modals when previewed individually in Fractal.
        if (document.body.classList.contains('js-modal-preview')) {
          openModal(modals[i].getAttribute('id'));
        }
        document.body.appendChild(modals[i]);
        modals[i].classList.add('js-component-init');
      }
    }

    for (let i = 0; i < modalOpenLinks.length; i++) {
      if (!modalOpenLinks[i].classList.contains('js-component-init')) {
        modalOpenLinks[i].addEventListener('click', handleOpenModal);
        modalOpenLinks[i].classList.add('js-component-init');

        // Remove disabled class after component init if present.
        if (modalOpenLinks[i].classList.contains('js-button-disabled')) {
          modalOpenLinks[i].classList.remove('js-button-disabled');
        }
      }
    }
  }

  // Allow application JS to reinitialize any instances added with Ajax, etc.
  if (typeof componentEvents !== 'undefined') {
    componentEvents.on('component-init', init);
    componentEvents.on('open-modal', handleOpenModalEvent);
    componentEvents.on('close-modal', handleCloseModalEvent);
  }

  init();

})(this);
